import { useDispatch, useSelector } from "react-redux";
import { cacheApiRequest } from "../utils/cacheApiRequest";
import { clearCache, clearAllCacheForBaseKey } from "../store/cacheSlice";

export const useReportDataService = () => {
  const dispatch = useDispatch();
  const cache = useSelector((state) => state.cache.cache);

  const fetchDeviceLog = async (
    params = { employeeID: "All" },
    forceRefresh = false
  ) => {
    const key = "REPORTS_GET_DEVICE_LOG";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchValidationLog = async (
    params = { employeeID: "All", logsDate: "2024-01-01" },
    forceRefresh = false
  ) => {
    const key = "REPORTS_GET_VALIDATION_LOG";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchEmployeeValidationData = async (
    params = { employeeID: "All" },
    forceRefresh = false
  ) => {
    const key = "REPORTS_GET_EMPLOYEE_VALIDATION_DATA";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchEmployeeValidationDataLogs = async (
    params = { employeeID: "All" },
    forceRefresh = false
  ) => {
    const key = "REPORTS_GET_EMPLOYEE_VALIDATION_DATA_LOGS";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchFailedLoginAttempts = async (
    params = { employeeID: "All", logsDate: "2024-01-01" },
    forceRefresh = false
  ) => {
    const key = "REPORTS_GET_FAILED_LOGIN_ATTEMPTS";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  return {
    fetchDeviceLog,
    fetchValidationLog,
    fetchEmployeeValidationData,
    fetchEmployeeValidationDataLogs,
    fetchFailedLoginAttempts,
  };
};
